import timestampSecondsToDateString from 'utils/timestampSecondsToDateString';

function getStartoverUrl(
    url: string,
    startTime: number | undefined,
    endTime: number | undefined,
) {
    if (startTime && endTime) {
        return url
            .replace('{startTime}', timestampSecondsToDateString(startTime))
            .replace('{endTime}', timestampSecondsToDateString(endTime));
    }

    return url;
}

export default getStartoverUrl;
